
<!-- <ag-charts
    *ngIf="isBrowser && options"
    [options]="options"
    style="width: 100%; height: 400px; display: block"
></ag-charts> -->
    <div class="trezo-card-title w-50">
        <h6 class="!mb-3 text-left">
            Training Budget
        </h6>
    </div>
    <div>
        <!-- <div class="filters flex gap-3 mb-4">
            <mat-form-field appearance="outline">
                <mat-label>District</mat-label>
                <mat-select >
                    <mat-option value="">Select District</mat-option>
                    <mat-option value="101">Nadia</mat-option>
                    <mat-option value="102">Jhargram</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Training</mat-label>
                <mat-select>
                    <mat-option value="">Select Training</mat-option>
                    <mat-option value="1001">Training 1</mat-option>
                    <mat-option value="1002">Training 2</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Session</mat-label>
                <mat-select >
                    <mat-option value="">Select Financial Year</mat-option>
                    <mat-option value="2025">2025-2026</mat-option>
                    <mat-option value="2024">2024-2025</mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->
        <div id="training_budget_chart" class="w-full"></div>
    </div>   
